import { Button } from "@progress/kendo-react-buttons";
import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { trashIcon } from "@progress/kendo-svg-icons";

type Props = {
  remove: (dataItem: any) => void;
} & GridCustomCellProps;

const PayCommandCell = (props: Props) => {
  const { dataItem } = props;

  return <td {...props.tdProps} className={[props.tdProps?.className, "k-command-cell"].filter(Boolean).join(" ")}>
      <Button
        icon="trash"
        svgIcon={trashIcon}
        themeColor="error"
        fillMode="outline"
        onClick={() =>
          dataItem.Description ? window.confirm(`Confirm removing ${dataItem.Description}?`) && props.remove(dataItem) : props.remove(dataItem)
        }
      />
    </td>
};

export default PayCommandCell;